export const ACCESS_SHARING_INDIVIDUAL_EQUIPMENT_STEPS = {
  ACCESS_SHARING: 0,
  OVERVIEW: 1,
} as const;
